export default __webpack_public_path__ + "static/media/mittelbaden_dark.10d77ee6.png";